<template>
<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title" id="itemDetailTitle">รายละเอียด</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12" style="margin-top:1rem;">
                <span style="font-size:1rem;color:#1890FF;">{{ transfer.transfer_date }}</span><br/>
                <span>รหัสคำสั่งซื้อ {{transfer.transfer_code}}</span><br/>
                <span>สถานะ </span>
                <span :class="[transfer.status === 'Cancel' ? 'status_cancel' : transfer.status === 'Success' ? 'status_success' : transfer.status === 'Waiting' ? '' : 'status_padding']">
                    {{ transfer.transfer_status }}
                </span>
                <span v-if="transfer.is_cancel_branch == 1">( {{ transfer.branch_in_name }} )</span> <span v-if="transfer.is_cancel_branch == 0 && transfer.status === 'Cancel' ">( ส่วนกลาง )</span><br/>
                <span v-if="transfer.remark != '' && transfer.remark != null">สาเหตุ {{ transfer.remark }}</span>
                <br v-if="transfer.remark != '' && transfer.remark != null" />
                <span>สาขาที่สั่งซื้อ {{ transfer.branch_in_name }}</span><br/>
                <span>สาขาที่โอนออก {{ transfer.branch_out_name }} </span><span class="sending-success" v-if="transfer.status == 'PaddingConfirm' || transfer.status == 'Success'" >นำส่งแล้ว</span><br/>
            </div>
        </div>
    </div>
    <div id="Tdtail" class="modal-body row pt-0 pb-0" style="margin-left:0;">
        <div class="col-12 p-2" style="overflow: auto;">
            <table style="width:100%">
                <thead>
                    <th>#</th>
                    <th>รายการสินค้า</th>
                    <th>จำนวน</th>
                </thead>
                <tbody>
                    <tr v-for="(d, i) in transfer.product" :key="'item'+i">
                        <td class="text-center">{{ i+1 }}</td>
                        <td class="text-left">{{ d.name }}</td>
                        <td class="text-center">{{ d.amount }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-footer" style="justify-content:center;" v-if="transfer.status == 'Waiting' || transfer.status == 'PaddingWaiting' || transfer.status == 'PaddingConfirm'">
      <button
        type="button"
        class="btn btn-secondary"
        v-if="transfer.status == 'Waiting'"
        @click="openDetailCancel()"
      >ยกเลิกคำสั่งซื้อ</button>
      <button
        type="button"
        class="btn btn-primary"
        v-if="transfer.status == 'PaddingWaiting' && !$store.state.isBranchTranfer"
        @click="saveStockOut()"
      >
        นำส่งสินค้า
      </button>
      <button
      type="button"
      class="btn btn-primary"
      v-if="transfer.status == 'PaddingConfirm' && $store.state.isBranchTranfer"
      @click="saveConfirmStockIn()"
    >
      ยอมรับสินค้า
    </button>
    </div>
</div>
</template>

<script>
import Swal from 'sweetalert2'
import apiMarim from '../services/service_undefined_v2'

export default {
  // name: 'stockOutInfo',
  props: ['item'],
  data () {
    return {
      transfer: []
    }
  },
  created () {
  },
  methods: {
    getDetailTransfer () {
      this.transfer = this.$store.state.transfer_detail
      console.log(this.$store.state.transfer_detail)
      this.$store.state.transfer_id = this.transfer.transfer_id
    },
    openDetailCancel () {
      $('#itemStockOutInfoCancel').modal('show')
    },
    saveConfirmStockIn () {
      Swal.fire({
        title: 'ยืนยันการยอมรับสินค้า',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#007CFF',
        cancelButtonText: 'ปิด',
        cancelButtonColor: '#6C767E',
        confirmButtonText: 'ยืนยัน',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          // $('#itemStockOutInfo').modal('hide')
          apiMarim.approveInTransferStock({
            transfer_id: this.transfer.transfer_id,
            branch_in_name: this.transfer.branch_in_name,
            transfer_product: this.transfer.product
          }, result => {
            if (result.data.status) {
              $('#itemStockOutInfo').modal('hide')
              this.$store.state.transfer_detail.status = 'Success'
              this.$store.state.transfer_detail.transfer_status = 'สำเร็จ'
              this.$notification['success']({
                message: 'แจ้งเตือน',
                description:
                  'ยอมรับสินค้าสำเร็จ'
              })
            } else {
              this.$notification['warning']({
                message: 'แจ้งเตือน',
                description:
                  'ยอมรับสินค้า ไม่สำเร็จ'
              })
            }
          }, errors => {
            this.$notification['warning']({
              message: 'แจ้งเตือน',
              description:
                'ยอมรับสินค้า ไม่สำเร็จ'
            })
          })
        }
      })
    },
    saveStockOut () {
      Swal.fire({
        title: 'ยืนยันการนำส่งสินค้า',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#007CFF',
        cancelButtonText: 'ปิด',
        cancelButtonColor: '#6C767E',
        confirmButtonText: 'ยืนยัน',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          apiMarim.approveOutTransferStock({
            transfer_id: this.transfer.transfer_id,
            branch_out_name: this.transfer.branch_out_name
          }, result => {
            if (result.data.status) {
              $('#itemStockOutInfo').modal('hide')
              this.$store.state.transfer_detail.status = 'PaddingConfirm'
              this.$notification['success']({
                message: 'แจ้งเตือน',
                description:
                  'นำส่งสินค้าสำเร็จ'
              })
            } else {
              this.$notification['warning']({
                message: 'แจ้งเตือน',
                description:
                  'นำส่งสินค้า ไม่สำเร็จ'
              })
            }
          }, errors => {
            this.$notification['warning']({
              message: 'แจ้งเตือน',
              description:
                'นำส่งสินค้า ไม่สำเร็จ'
            })
          })
        }
      })
    }
  },
  mounted () {
    $('#itemStockOutInfo').on(
      'show.bs.modal',
      function () {
        this.getDetailTransfer()
      // eslint-disable-next-line no-extra-bind
      }.bind(this)
    )
  }
}
</script>

<style scoped>
.form-control:-moz-read-only {
  /* For Firefox */
  background-color: #fff;
}

.form-control:read-only {
  background-color: #fff;
}

#Tdtail {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#Tdtail td, #Tdtail th {
  border: 1px solid #ddd;
  padding: 5px;
}

#Tdtail tr:nth-child(even){background-color: #f2f2f2;}

#Tdtail tr:hover {background-color: #ddd;}

#Tdtail th {
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: center;
  background-color: #007bff;
  color: white;
}

.status_padding {
  color:#FFC721;
}

.status_success {
  color:#1F9524;
}

.status_cancel {
  color:#E04857;
}

.sending-success {
  background-color: #359E39;
  color: white;
  border:1px solid #359E39;
  font-size: 0.875rem;
  padding: 2px 4px;
  border-radius: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/stock_info.vue